module.exports = __webpack_public_path__ + "static/media/hiImTori.0ac50860.mp3";